import { SvgIcon, SvgIconProps } from "@mui/material";

const TableTab = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M23.229 15.2463H13.3206C12.9515 15.2463 12.6523 15.5455 12.6523 15.9145C12.6523 16.2836 12.9515 16.5828 13.3206 16.5828H23.229C23.5981 16.5828 23.8973 16.2836 23.8973 15.9145C23.8973 15.5455 23.5981 15.2463 23.229 15.2463ZM23.229 10.2344H13.3206C12.9515 10.2344 12.6523 10.5336 12.6523 10.9026C12.6523 11.2717 12.9515 11.5709 13.3206 11.5709H23.229C23.5981 11.5709 23.8973 11.2717 23.8973 10.9026C23.8973 10.5336 23.5981 10.2344 23.229 10.2344ZM23.229 20.2582H13.3206C12.9515 20.2582 12.6523 20.5574 12.6523 20.9265C12.6523 21.2955 12.9515 21.5947 13.3206 21.5947H23.229C23.5981 21.5947 23.8973 21.2955 23.8973 20.9265C23.8973 20.5574 23.5981 20.2582 23.229 20.2582Z"
      fill="currentColor"
      fillRule="evenodd" clipRule="evenodd" 
    />
    <path
      d="M9.40217 12.5035C10.2866 12.5035 11.0036 11.7865 11.0036 10.9021C11.0036 10.0177 10.2866 9.30078 9.40217 9.30078C8.51775 9.30078 7.80078 10.0177 7.80078 10.9021C7.80078 11.7865 8.51775 12.5035 9.40217 12.5035Z"
      fill="currentColor"
      fillRule="evenodd" clipRule="evenodd" 
    />
    <path
      d="M9.40217 17.5152C10.2866 17.5152 11.0036 16.7982 11.0036 15.9138C11.0036 15.0294 10.2866 14.3125 9.40217 14.3125C8.51775 14.3125 7.80078 15.0294 7.80078 15.9138C7.80078 16.7982 8.51775 17.5152 9.40217 17.5152Z"
      fill="currentColor"
      fillRule="evenodd" clipRule="evenodd" 
    />
    <path
      d="M9.40217 22.5269C10.2866 22.5269 11.0036 21.81 11.0036 20.9256C11.0036 20.0412 10.2866 19.3242 9.40217 19.3242C8.51775 19.3242 7.80078 20.0412 7.80078 20.9256C7.80078 21.81 8.51775 22.5269 9.40217 22.5269Z"
      fill="currentColor"
      fillRule="evenodd" clipRule="evenodd" 
    />
    <path
      d="M13.6289 15.9141L23.1406 15.9141"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M13.6289 10.9023L23.1406 10.9023"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M13.6289 20.9258L23.1406 20.9258"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </SvgIcon>
);

export default TableTab;